import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl mt-0 font-bold" }, "Stammdaten", -1)
const _hoisted_3 = { class: "w-full flex justify-between items-start mt-4" }
const _hoisted_4 = { class: "flex flex-col gap-2 items-start justify-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-left font-semibold flex items-center pr-4" }, "Bauvorhaben", -1)
const _hoisted_6 = { class: "flex flex-col gap-2 justify-start items-end ml-4" }
const _hoisted_7 = { key: 0 }

import { useSelectedProject } from '@/store/selectedProject'
import { useType } from '@/store/type'
import { LaunchNavigator } from '@awesome-cordova-plugins/launch-navigator'
import { alertController } from '@ionic/core'
import { map } from 'ionicons/icons'
import { IonIcon } from '@ionic/vue'
import LabelAndValueDiv from '@/components/DetailPage/LabelAndValueDiv.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseData',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const typeStore = useType()

async function navigate() {
  if(await LaunchNavigator.isAppAvailable(LaunchNavigator.APP.APPLE_MAPS)) {
    await LaunchNavigator.navigate(selectedProjectStore.project.construction.street + " " + selectedProjectStore.project.construction.no + " " + selectedProjectStore.project.construction.city + " " + selectedProjectStore.project.construction.country, {
      app: LaunchNavigator.APP.APPLE_MAPS
    })
  } else if(await LaunchNavigator.isAppAvailable(LaunchNavigator.APP.GOOGLE_MAPS)) {
    await LaunchNavigator.navigate(selectedProjectStore.project.construction.street + " " + selectedProjectStore.project.construction.no + " " + selectedProjectStore.project.construction.city + " " + selectedProjectStore.project.construction.country, {
      app: LaunchNavigator.APP.GOOGLE_MAPS
    })
  } else {
    const toast = await alertController.create({
      message: 'Sie müssen Google Maps oder Apple Maps auf ihrem Gerät haben um diese Funktion nutzen zu können',
      buttons: ['OK']
    })
    return await toast.present()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createVNode(LabelAndValueDiv, {
        label: "Nr",
        value: _unref(selectedProjectStore).project.formattedProjectNo ? _unref(selectedProjectStore).project.formattedProjectNo : _unref(selectedProjectStore).project.number.toString()
      }, null, 8, ["value"]),
      _createVNode(LabelAndValueDiv, {
        label: "Name",
        value: _unref(selectedProjectStore).project.name
      }, null, 8, ["value"]),
      _createVNode(LabelAndValueDiv, {
        label: "Status",
        value: _unref(typeStore).statusTypes.find(statusType => statusType.value === _unref(selectedProjectStore).project.status)!.titel
      }, null, 8, ["value"]),
      (_unref(typeStore).getOneProjectType(_unref(selectedProjectStore).project.type))
        ? (_openBlock(), _createBlock(LabelAndValueDiv, {
            key: 0,
            label: "Projektyp",
            value: _unref(typeStore).getOneProjectType(_unref(selectedProjectStore).project.type)!.titel
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode(_unref(IonIcon), {
            icon: _unref(map),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate())),
            class: "cursor-pointer w-5 h-5"
          }, null, 8, ["icon"]), [
            [_vShow, _unref(selectedProjectStore).project.construction.country !== '']
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", null, _toDisplayString(_unref(selectedProjectStore).project.construction.name), 1),
          (_unref(selectedProjectStore).project.construction.street || _unref(selectedProjectStore).project.construction.no)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(_unref(selectedProjectStore).project.construction.street) + " " + _toDisplayString(_unref(selectedProjectStore).project.construction.no), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("label", null, _toDisplayString(_unref(selectedProjectStore).project.construction.country) + ", " + _toDisplayString(_unref(selectedProjectStore).project.construction.city), 513), [
            [_vShow, _unref(selectedProjectStore).project.construction.country !== '']
          ])
        ])
      ]),
      (_unref(selectedProjectStore).project.area && _unref(selectedProjectStore).project.area_unit && _unref(selectedProjectStore).project.area !== null && _unref(selectedProjectStore).project.area_unit !== null)
        ? (_openBlock(), _createBlock(LabelAndValueDiv, {
            key: 1,
            label: "Fläche",
            value: _unref(selectedProjectStore).project.area + ' ' + _unref(selectedProjectStore).project.area_unit
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})